module.exports = __webpack_public_path__ + "b8da5ad982b6a9846209583c0bae04e3.pdf";